import React, { useEffect, useState, useContext } from 'react';
import IframeResizer from 'iframe-resizer-react';

import PardotContext from '../../context/PardotContext';

function getUserDevice() {
  const userAgent = navigator.userAgent;
  if (
    /Mobile|Android|iPhone|iPad|iPod|Windows Phone|BlackBerry|Kindle|Silk|Opera Mini|IEMobile|Tablet/i.test(
      userAgent
    )
  ) {
    return 'Mobile Device';
  } else if (/Tablet|iPad/i.test(userAgent)) {
    return 'Tablet';
  } else {
    return 'Desktop';
  }
}

const PardotForm = ({ url }) => {
  const [formUrl, setFormUrl] = useState('');

  const {
    utm,
    setUtm,
    email: contextEmail,
    wavelyticsParsedAnswers, // <-- Ensure you are destructuring this from context
  } = useContext(PardotContext);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pageUrlWithoutUtm = window.location.href.split('?')[0];
      const userDevice = getUserDevice();
      const encodedUserDevice = encodeURIComponent(userDevice);
      const encodedPageURL = encodeURIComponent(pageUrlWithoutUtm);

      let params = [];

      // Add UTM parameters
      if (utm) {
        params.push(utm);
      } else {
        const utmFromPageURL = window.location.search.substring(1);
        if (utmFromPageURL) {
          setUtm(utmFromPageURL);
          params.push(utmFromPageURL);
        }
      }

      // Add device and referral URL parameters
      params.push(`Device_Type=${encodedUserDevice}`);
      params.push(`Form_Referral_URL=${encodedPageURL}`);

      // Add email parameter if available
      if (contextEmail) {
        params.push(`email=${encodeURIComponent(contextEmail)}`);
      }

      // THIS IS THE CRITICAL PART FOR WAVELYTICS COMMENTS
      // Ensure wavelyticsParsedAnswers is present and added to params
      if (wavelyticsParsedAnswers) {
        // 'comments' should be the exact URL parameter name Pardot expects for your hidden field.
        // Double-check this name in your Pardot form's configuration.
        params.push(`comments=${encodeURIComponent(wavelyticsParsedAnswers)}`);
      }

      const queryString = params.filter(Boolean).join('&'); // Filter out any empty params before joining
      const separator = url.includes('?') ? '&' : '?';

      setFormUrl(url + (queryString ? separator + queryString : ''));
    }
  }, [
    url,
    utm,
    setUtm,
    contextEmail,
    wavelyticsParsedAnswers, // <-- Crucial: Add this to the dependency array
  ]);

  return (
    <>
      {!!formUrl.length ? (
        <IframeResizer
          className='pardotform'
          src={formUrl}
          allowtransparency="true" // Corrected prop name
          style={{ width: '1px', minWidth: '100%', border: 0 }}
        />
      ) : null}
    </>
  );
};

export default PardotForm;